import { NgModule } from '@angular/core';

import { HomePageModule } from 'pages/home/home.module';
import { FatalErrorPageModule } from 'pages/fatal-error/fatal-error.module';
import { ChangelogPageModule } from 'pages/changelog/changelog.module';
import { HelpPageModule } from 'pages/help-page/help-page.module';
import { HelpCardPageModule } from 'pages/help-card-page/help-card-page.module';
import { NotePageModule } from 'pages/note-page/note-page.module';
import { TaskCalendarPageModule } from 'pages/task-calendar-page/task-calendar-page.module';
import { InputCalendarPageModule } from 'pages/input-calendar-page/input-calendar-page.module';
import { ProgressPageModule } from 'pages/progress/progress.module';
import { EditWeighInPageModule } from 'pages/edit-weigh-in/edit-weigh-in.module';
import { WeeklyCheckupPageModule } from 'pages/weekly-checkup/weekly-checkup-page.module';
import { SendFeedbackPageModule } from 'pages/send-feedback/send-feedback.module';

const CORE_PAGE_MODULES = [
  HomePageModule,
  FatalErrorPageModule,
  ChangelogPageModule,
  HelpPageModule,
  HelpCardPageModule,
  NotePageModule,
  TaskCalendarPageModule,
  InputCalendarPageModule,
  ProgressPageModule,
  EditWeighInPageModule,
  WeeklyCheckupPageModule,
  SendFeedbackPageModule,
];

/**
 * The screens that belong to no single feature — the home screen, the app
 * shell, and the small screens reachable from many places.
 *
 * One of the app's per-area page groups: it only groups page modules together,
 * declaring nothing of its own and adding no providers. Why these files exist and
 * what keeps them honest: `design-docs/angular-components.md`, "Creating New
 * Components", step 4.
 */
@NgModule({
  imports: CORE_PAGE_MODULES,
  exports: CORE_PAGE_MODULES,
})
export class CorePagesModule { }
